import React from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import { MetaResourceRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaResourceRenderer';
import { withGuidedHouseholdReviewLayout } from 'Components/UI/guidedHouseholdReview/layoutWrapper';
import { GuidedHouseholdReviewIntroToGoalThresholdsLayout } from './layout';
import { metaOverrideSet } from './metaOverrideSet';

const layout = withGuidedHouseholdReviewLayout(GuidedHouseholdReviewIntroToGoalThresholdsLayout, { hideTitle: true, customButtons: true });

export const GuidedHouseholdReviewIntroToGoalThresholdsPageTemplate = ({ resource }) => {
  const { loadPageContentLink, setPageContentCollection } = usePageContentContext();
  return (
    <MetaResourceRenderer
      metaOverrideSet={metaOverrideSet}
      onSubmit={setPageContentCollection}
      layout={layout}
      LayoutProps={{ navigateToLink: loadPageContentLink }}
      resource={resource}
    />
  );
};

GuidedHouseholdReviewIntroToGoalThresholdsPageTemplate.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};
